export default __webpack_public_path__ + "static/media/owen.a2c38151.png";